const listOfCitiesWithLatLng = {
    "aachen": { lat: 50.775555, lng: 6.083611 },
    "augsburg": { lat: 48.366512, lng: 10.894446 },
    "bergischgladbach": { lat: 51.099998, lng: 7.116667 },
    "gladbach": { lat: 51.099998, lng: 7.116667 },
    "bielefeld": { lat: 52.021111, lng: 8.534722 },
    "bochum": { lat: 51.481846, lng: 7.216236 },
    "bonn": { lat: 50.733334, lng: 7.100000 },
    "bottrop": { lat: 51.524723, lng: 6.922778 },
    "braunschweig": { lat: 52.266666, lng: 10.516667 },
    "bremen": { lat: 53.073635, lng: 8.806422 },
    "bremerhaven": { lat: 53.549999, lng: 8.583333 },
    "chemnitz": { lat: 50.833332, lng: 12.916667 },
    "cologne": { lat: 50.935173, lng: 6.953101 },
    "cottbus": { lat: 51.756310, lng: 14.332868 },
    "darmstadt": { lat: 49.878708, lng: 8.646927 },
    "dortmund": { lat: 51.514244, lng: 7.468429 },
    "dresden": { lat: 51.050407, lng: 13.737262 },
    "duisburg": { lat: 51.435146, lng: 6.762692 },
    "dusseldorf": { lat: 51.233334, lng: 6.783333 },
    "erfurt": { lat: 50.983334, lng: 11.033333 },
    "erlangen": { lat: 49.583332, lng: 11.016667 },
    "essen": { lat: 51.450832, lng: 7.013056 },
    "frankfurtammain": { lat: 50.110924, lng: 8.682127 },
    "frankfurt": { lat: 50.110924, lng: 8.682127 },
    "freiburg": { lat: 47.997791, lng: 7.842609 },
    "fulda": { lat: 50.555809, lng: 9.680845 },
    "furth": { lat: 49.466667, lng: 11.000000 },
    "gelsenkirchen": { lat: 51.516666, lng: 7.100000 },
    "gera": { lat: 50.884842, lng: 12.079811 },
    "gottingen": { lat: 51.545483, lng: 9.905548 },
    "grimma": { lat: 51.236443, lng: 12.720231 },
    "hagen": { lat: 51.366669, lng: 7.483333 },
    "halle": { lat: 51.483334, lng: 11.966667 },
    "hamburg": { lat: 53.551086, lng: 9.993682 },
    "hanover": { lat: 52.373920, lng: 9.735603 },
    "heidelberg": { lat: 49.398750, lng: 8.672434 },
    "heilbronn": { lat: 49.150002, lng: 9.216600 },
    "hildesheim": { lat: 52.150002, lng: 9.950000 },
    "hilden": { lat: 51.167858, lng: 6.935225 },
    "jena": { lat: 50.927223, lng: 11.586111 },
    "karlsruhe": { lat: 49.006889, lng: 8.403653 },
    "kassel": { lat: 51.312801, lng: 9.481544 },
    "kiel": { lat: 54.323334, lng: 10.139444 },
    "koblenz": { lat: 50.360023, lng: 7.589907 },
    "krefeld": { lat: 51.333332, lng: 6.566667 },
    "leipzig": { lat: 51.340199, lng: 12.360103 },
    "leverkusen": { lat: 51.033333, lng: 6.983333 },
    "ludwigshafen": { lat: 49.477409, lng: 8.445180 },
    "lubeck": { lat: 53.869720, lng: 10.686389 },
    "magdeburg": { lat: 52.133331, lng: 11.616667 },
    "mainz": { lat: 49.992863, lng: 8.247253 },
    "mannheim": { lat: 49.488888, lng: 8.469167 },
    "meissen": { lat: 51.164703, lng: 13.496017 },
    "monchengladbach": { lat: 51.200001, lng: 6.433333 },
    "moers": { lat: 51.451603, lng: 6.640815 },
    "muelheim": { lat: 51.433334, lng: 6.883333 },
    "muelheimanderruhr": { lat: 51.433334, lng: 6.883333 },
    "munich": { lat: 48.137154, lng: 11.576124 },
    "munster": { lat: 51.961563, lng: 7.628202 },
    "neuss": { lat: 51.200001, lng: 6.700000 },
    "nuremberg": { lat: 49.460983, lng: 11.061859 },
    "offenbach": { lat: 50.099998, lng: 8.800000 },
    "offenbachammain": { lat: 50.099998, lng: 8.800000 },
    "oldenburg": { lat: 53.143890, lng: 8.213889 },
    "oranienburg": { lat: 52.753727, lng: 13.236681 },
    "osnabruck": { lat: 52.283333, lng: 8.050000 },
    "paderborn": { lat: 51.716667, lng: 8.766667 },
    "pforzheim": { lat: 48.901943, lng: 8.716667 },
    "remscheid": { lat: 51.183334, lng: 7.200000 },
    "reutlingen": { lat: 48.483334, lng: 9.216667 },
    "recklinghausen": { lat: 51.584999, lng: 7.161944 },
    "regensburg": { lat: 49.013432, lng: 12.101624 },
    "salzgitter": { lat: 52.150002, lng: 10.333333 },
    "saarbrucken": { lat: 49.233334, lng: 7.000000 },
    "siegen": { lat: 50.883331, lng: 8.016667 },
    "solingen": { lat: 51.170208, lng: 7.083141 },
    "stuttgart": { lat: 48.783333, lng: 9.183333 },
    "tubingen": { lat: 48.521637, lng: 9.057645 },
    "trier": { lat: 49.750000, lng: 6.633333 },
    "ulm": { lat: 48.400002, lng: 9.983333 },
    "weimar": { lat: 50.979492, lng: 11.323544 },
    "wernigerode": { lat: 51.837635, lng: 10.783489 },
    "wiesbaden": { lat: 50.078217, lng: 8.239761 },
    "wolfsburg": { lat: 52.427547, lng: 10.780420 },
    "wuppertal": { lat: 51.256214, lng: 7.150764 },
    "wurzburg": { lat: 49.783333, lng: 9.933333 }
};
export default listOfCitiesWithLatLng;
